import { Controller, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { PrioritizedToggleCard } from './prioritized-toggle-card';

import type { PrioritizedMessageFieldProps } from '@/types/predefined-messages';

import { FieldLabel } from '@/components/ui/field';
import { isPriorityRecipientSelected } from '@/lib/helpers/predefined-messages';

export function PrioritizedMessageField({ control }: PrioritizedMessageFieldProps) {
  const { t } = useTranslation();
  const recipientIds = useWatch({ control, name: 'recipientIds' }) ?? [];
  const disabled = !isPriorityRecipientSelected(recipientIds);

  return (
    <div className="space-y-2">
      <FieldLabel className="text-sm font-medium">
        {t('common:prioritizedMessage.label')}{' '}
        <span className="text-muted-foreground font-normal">
          {t('common:prioritizedMessage.hint')}
        </span>
      </FieldLabel>
      <Controller
        name="prioritized"
        control={control}
        render={({ field: { value, onChange } }) => (
          <PrioritizedToggleCard checked={value} onCheckedChange={onChange} disabled={disabled} />
        )}
      />
    </div>
  );
}
